// Collection List Enhancement Script
// This script transforms the basic collection grid into a styled overlay version

document.addEventListener('DOMContentLoaded', function() {
    // Configuration for collection titles and categories
    const collectionData = {
        'kitchen-appliance': {
            title: 'KITCHEN APPLIANCE',
            buttonText: 'View More'
        },
        'cookware': {
            title: 'COOKWARE',
            buttonText: 'View More'
        },
        'kitchen-utensil': {
            title: 'KITCHEN UTENSIL',
            buttonText: 'View More'
        },
        'kitchen-knives': {
            title: 'KITCHEN KNIVES',
            buttonText: 'View More'
        }
    };

    // Find all collection items
    const collectionItems = document.querySelectorAll('.collection-list__item');
    
    collectionItems.forEach((item, index) => {
        enhanceCollectionItem(item, index);
    });

    function enhanceCollectionItem(item, index) {
        // Find the collection card within the item
        const collectionCard = item.querySelector('.collection__card');
        const collectionImage = item.querySelector('.collection__card-image');
        const collectionTitle = item.querySelector('.collection__card-title');
        
        if (!collectionCard || !collectionImage) return;

        // Get collection handle from data or URL
        const collectionHandle = getCollectionHandle(item, index);
        const collectionConfig = collectionData[collectionHandle] || getDefaultConfig(index);

        // Add overlay styling to the card
        addOverlayStyles(collectionCard);

        // Create and add the overlay content
        const overlayContent = createOverlayContent(collectionConfig);
        collectionCard.appendChild(overlayContent);

        // Hide original title if it exists
        if (collectionTitle) {
            collectionTitle.style.display = 'none';
        }

        // Add hover effects
        addHoverEffects(collectionCard);
    }

    function getCollectionHandle(item, index) {
        // Try to get collection handle from various sources
        const link = item.querySelector('a[href*="/collections/"]');
        if (link) {
            const href = link.getAttribute('href');
            const match = href.match(/\/collections\/([^\/\?]+)/);
            if (match) return match[1];
        }

        // Fallback to index-based mapping
        const handles = ['kitchen-appliance', 'cookware', 'kitchen-utensil', 'kitchen-knives'];
        return handles[index] || 'default';
    }

    function getDefaultConfig(index) {
        const defaultTitles = ['KITCHEN APPLIANCE', 'COOKWARE', 'KITCHEN UTENSIL', 'KITCHEN KNIVES'];
        return {
            title: defaultTitles[index] || 'COLLECTION',
            buttonText: 'View More'
        };
    }

    function addOverlayStyles(card) {
        // Add CSS styles for overlay effect
        card.style.position = 'relative';
        card.style.overflow = 'hidden';
        card.style.borderRadius = '8px';
        card.style.transition = 'transform 0.3s ease';

        // Ensure image fills the card
        const image = card.querySelector('img');
        if (image) {
            image.style.width = '100%';
            image.style.height = '100%';
            image.style.objectFit = 'cover';
            image.style.transition = 'transform 0.3s ease';
        }
    }

    function createOverlayContent(config) {
        // Create overlay container
        const overlay = document.createElement('div');
        overlay.className = 'collection-overlay';
        overlay.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: white;
            text-align: center;
            padding: 20px;
            transition: background 0.3s ease;
        `;

        // Create title
        const title = document.createElement('h3');
        title.textContent = config.title;
        title.style.cssText = `
            font-size: 18px;
            font-weight: 600;
            margin: 0 0 15px 0;
            letter-spacing: 1px;
            text-transform: uppercase;
        `;

        // Create button
        const button = document.createElement('button');
        button.textContent = config.buttonText;
        button.className = 'collection-overlay-btn';
        button.style.cssText = `
            background: #FFD700;
            color: #333;
            border: none;
            padding: 8px 20px;
            font-size: 14px;
            font-weight: 600;
            border-radius: 4px;
            cursor: pointer;
            transition: all 0.3s ease;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        `;

        // Add button hover effect
        button.addEventListener('mouseenter', function() {
            this.style.background = '#FFC107';
            this.style.transform = 'translateY(-2px)';
        });

        button.addEventListener('mouseleave', function() {
            this.style.background = '#FFD700';
            this.style.transform = 'translateY(0)';
        });

        // Add click handler to button
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const link = overlay.closest('.collection-list__item').querySelector('a');
            if (link) {
                window.location.href = link.getAttribute('href');
            }
        });

        overlay.appendChild(title);
        overlay.appendChild(button);

        return overlay;
    }

    function addHoverEffects(card) {
        const overlay = card.querySelector('.collection-overlay');
        const image = card.querySelector('img');

        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-5px)';
            if (overlay) {
                overlay.style.background = 'rgba(0, 0, 0, 0.6)';
            }
            if (image) {
                image.style.transform = 'scale(1.05)';
            }
        });

        card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
            if (overlay) {
                overlay.style.background = 'rgba(0, 0, 0, 0.4)';
            }
            if (image) {
                image.style.transform = 'scale(1)';
            }
        });
    }

    // Optional: Add responsive styles
    function addResponsiveStyles() {
        const style = document.createElement('style');
        style.textContent = `
            @media (max-width: 768px) {
                .collection-overlay h3 {
                    font-size: 16px !important;
                }
                .collection-overlay-btn {
                    padding: 6px 16px !important;
                    font-size: 12px !important;
                }
            }
        `;
        document.head.appendChild(style);
    }

    addResponsiveStyles();
});

// Alternative initialization if DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCollectionEnhancement);
} else {
    initializeCollectionEnhancement();
}

function initializeCollectionEnhancement() {
    // Re-run the enhancement if collections are loaded dynamically
    setTimeout(() => {
        const event = new Event('DOMContentLoaded');
        document.dispatchEvent(event);
    }, 100);
}